import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { OrganizationData, UserContextService } from 'src/app/core/services/user-context.service';
import { SharedService } from 'src/app/core/services/shared-service';

@Component({
  selector: 'app-new-organization',
  templateUrl: './new-organization.component.html',
  styleUrl: './new-organization.component.scss'
})
export class NewOrganizationComponent {
  organization: OrganizationData = {
    Name: '',
    Address: '',
    Country: '',
    City: '',
    State: '',
    PostalCode: '',
    Phone: ''
  };

  isSaving: boolean = false;
  isPhoneValid: boolean = true;
  hasChanges: boolean = false;

  constructor(
    private userContextService: UserContextService,
    private router: Router,
    private sharedService: SharedService
  ) {}

  async continue() {
    if (this.isPhoneValid) {
      this.isSaving = true;
      try {
        await this.userContextService.SetUpNewOrganizaton(this.organization);
        this.router.navigate(['/onboarding/pricing']);
      }catch (error) {
        console.error('Error saving organization:', error);
        this.sharedService.DisplayNotification('Error saving organization', 'error');
      } finally {
        this.isSaving = false;
      }
    }
  }

  onFieldChange(): void {
    this.hasChanges = true;
  }

  validatePhone(): void {
    const phoneRegex = /^\+?(\d{1,3})?[-.\s]?\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}$/;
    this.isPhoneValid = phoneRegex.test(this.organization.Phone || '');
  }

  validateName(): void {
    this.hasChanges = this.organization.Name.length > 0;
  }

    onBack(): void {
      this.router.navigate(['/settings/organizations']);
    }
}
